import { render } from "./App.vue?vue&type=template&id=63cd6862"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=63cd6862&lang=css"

import exportComponent from "/Users/michaelhu/GWS/GitLab/onemeasure/web/panel360/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__